

import "./App.css";







import Allroutes from './router/allroutes';
import Footer from './component/Saurabh/Footer';

function App() {
  return (
    <div className="App">


    <Allroutes/>
    <Footer/>
    </div>
  );
}

export default App;

